export default "__VITE_PUBLIC_ASSET__4053ea99__"